import React, {useState} from "react";
import {useTalent} from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";
import ProfileSchoolRow from "../components/ProfileSchoolRow";

const MAX_LENGTH = 3;

const TalentProfileEducation = ({items}) => {
    const [isMoreOpen, setIsMoreOpen] = useState(false);

    return (
        <div id="education" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <h4 className="textbold text-lg">Education  {!!items?.length && `(${items.length})`}</h4>

                    {!items?.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Education Available</p>
                        </div>
                    )}

                    <div className="flex flex-col divide-y">

                        {items?.slice(0, isMoreOpen ? items.length : MAX_LENGTH).map(school => (
                            <ProfileSchoolRow key={school.id} school={school} />
                        ))}
                    </div>

                    {items?.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsMoreOpen(!isMoreOpen)}
                            >
                                <p>{items.length - MAX_LENGTH} {isMoreOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isMoreOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileEducation;

const TalentProfileEducation2 = () => {
    const { talent } = useTalent();

    return (
        <ProfileContainer>
            <div id="education">

                <h4 className="text-bold font-xl pb-6">Education</h4>

                <div className="flex flex-col gap-6 pb-6">
                    {talent.schools?.map(school => {
                        return (
                            <div key={school.id} className="flexjustify-between">
                                <div>
                                    <p className="font-lg font-bold">{school.earned_degree}</p>
                                    <p>{school.field_of_study}</p>
                                    <p>{school.name}</p>
                                    <p className="text-wrippleBlueGray">{TB.moment(school.started_at).format('ll')} - {school.ended_at ? TB.moment(school.ended_at).format('ll') : 'Now'}</p>
                                </div>

                                {/* <div>
                                <button type="button" className="btn btn-outline-dark">
                                    View Work Responsibilities
                                </button>
                            </div> */}
                            </div>
                        )
                    })}
                </div>

            </div>

            <div id="awards">

                <h4 className="text-bold font-xl pb-6">Awards</h4>

                <div className="flex flex-col gap-6 pb-6">
                    {talent.awards?.map(award => {
                        return (
                            <div className="flex justify-between">
                                format this
                                {/* <div>
                    <p className="font-lg font-bold">{job.role}</p>
                    <p>{job.employer}</p>
                    <p className="text-wrippleBlueGray">{TB.moment(job.started_at).format('ll')} - {job.ended_at ? TB.moment(job.ended_at).format('ll') : 'Now'}</p>
                </div>

                <div>
                    <button type="button" className="btn btn-outline-dark">
                        View Work Responsibilities
                    </button>
                </div> */}
                            </div>
                        )
                    })}
                </div>
            </div>

            <div id="certifications">

                <h4 className="text-bold font-xl pb-6">Certifications</h4>

                <div className="flex flex-col gap-6">
                    {talent.awards?.map(award => {
                        return (
                            <div className="flex justify-between">
                                format this
                                {/* <div>
                    <p className="font-lg font-bold">{job.role}</p>
                    <p>{job.employer}</p>
                    <p className="text-wrippleBlueGray">{TB.moment(job.started_at).format('ll')} - {job.ended_at ? TB.moment(job.ended_at).format('ll') : 'Now'}</p>
                </div>

                <div>
                    <button type="button" className="btn btn-outline-dark">
                        View Work Responsibilities
                    </button>
                </div> */}
                            </div>
                        )
                    })}
                </div>
            </div>
        </ProfileContainer>
    )
}

// export default TalentProfileEducation2;